module.exports = __webpack_public_path__ + "img/new1.2426b7de.png";